import { getTodayCivilDate, isValidCivilDate, parseCivilDate } from './dates';

const pad = (value) => String(value).padStart(2, '0');

const isLeapYear = (year) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);

const getDaysInMonth = (year, month) => {
  if (month === 2) return isLeapYear(year) ? 29 : 28;
  return [4, 6, 9, 11].includes(month) ? 30 : 31;
};

export const addCivilDays = (civilDate, days) => {
  const parsed = parseCivilDate(civilDate);
  if (!parsed || !Number.isSafeInteger(days) || days < 0) return null;

  let { year, month, day } = parsed;
  let remaining = days;
  while (remaining > 0) {
    day += 1;
    if (day > getDaysInMonth(year, month)) {
      day = 1;
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
    }
    remaining -= 1;
  }
  return `${year}-${pad(month)}-${pad(day)}`;
};

export const getUpcomingFinancialRange = (today = getTodayCivilDate()) => {
  if (!isValidCivilDate(today)) return null;
  return { startDate: today, endDate: addCivilDays(today, 30) };
};

const MONTH_LABELS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

export const formatShortCivilDate = (civilDate, includeYear = false) => {
  const parsed = parseCivilDate(civilDate);
  if (!parsed) return '';
  const label = `${parsed.day} ${MONTH_LABELS[parsed.month - 1]}`;
  return includeYear ? `${label} ${parsed.year}` : label;
};

export const formatCivilRangeLabel = (startDate, endDate) => {
  const start = parseCivilDate(startDate);
  const end = parseCivilDate(endDate);
  if (!start || !end || startDate > endDate) return '';
  const crossesYear = start.year !== end.year;
  return `${formatShortCivilDate(startDate, crossesYear)} — ${formatShortCivilDate(endDate, crossesYear)}`;
};
